/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Dropdown from "../../../../components/common/new/Dropdown/Dropdown";
import Typography from "../../../../components/common/new/Typography/Typography";
import GohonzonOtherInput from "../../../../components/GohonzonOtherInput/GohonzonOtherInput";
import { GOHONZON_SUBMISSION } from "../../../../contants/formFields";
import styles from "../GohonzonSubmission.styles";
import { selectAllSIUsers } from "../../../../redux/selectors/user";

function MemberInterviewedForm({
  regionIds,
  options,
  setRegionIds,
  values,
  handleChange,
  setFieldValue,
  interviewedBy,
  memberInfo,
}) {
  const { isHelpDesk, isHelpDeskAdmin } = useSelector(selectAllSIUsers);
  const gohonzonType = memberInfo.gohonzonType === "OKATAKI_GOHONZON";
  const { type } = useParams();

  const isTracking = type === "tracking";

  const isReturn = type === "return";

  const RadioValue =
    values[GOHONZON_SUBMISSION.DURATION_OF_PRACTICE] === "NO" ||
    values[GOHONZON_SUBMISSION.REGULAR_GONGYO_DAIMOKU] === "NO" ||
    values[GOHONZON_SUBMISSION.PERMISSION_TO_RECEIVE] === "NO" ||
    values[GOHONZON_SUBMISSION.PLACE_OF_ENSHRINED] === "NO";

  const readOnly = RadioValue;

  useEffect(() => {
    if (readOnly) {
      setFieldValue(GOHONZON_SUBMISSION.APPORVED_BY_ALL_COMMITE_MEMBERS, "NO");
    } else {
      setFieldValue(GOHONZON_SUBMISSION.APPORVED_BY_ALL_COMMITE_MEMBERS, null);
    }
  }, [readOnly]);

  return (
    <Box my={7}>
      {!isReturn &&
        (isHelpDesk || isHelpDeskAdmin || isTracking) &&
        gohonzonType && (
          <>
            <Box
              style={{
                width: "160px",
                height: "44px",
                flexShrink: "0",
                borderRadius: "35px",
                background: "#196AAB",
                marginBottom: "-20px",
                position: "relative",
                zIndex: "1",
                marginLeft: "45px",
              }}
            >
              <Typography
                variant="title3"
                style={{
                  color: "#FFF",
                  fontFeatureSettings: "'clig' off, 'liga' off",
                  fontFamily: "Noto Sans",
                  fontSize: "18px",
                  fontStyle: "normal",
                  fontWeight: "600",
                  lineHeight: "20px",
                  padding: "12px 20px 12px 20px",
                  margin: "0px",
                }}
              >
                Interviewed By
              </Typography>
            </Box>
            <Box
              style={{
                borderRadius: "5px 5px 5px 5px",
                border: "1px solid #C2D4EB",
                background: "#F6F6F6",
                padding: "30px 0px 20px 0px",
                borderBottom: "9px solid #196AAB",
                margin: "0px 20px",
              }}
            >
              <Box style={styles.interviewBy}>
                <Box flex={1.35} width="60%">
                  <Typography variant="mini" color="#5e5e5e" weight={600}>
                    Interviewed By:
                    <Typography variant="small" color="#FF6A69">
                      *
                    </Typography>
                  </Typography>
                </Box>
                <Box flex={1} style={styles.readOnlyInterviewBy}>
                  <Box style={styles.interviewByNames}>
                    <Typography>
                      {interviewedBy
                        ?.map((interview) => interview.fullName)
                        .join(", ") || "NA"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </>
        )}
      {!isHelpDesk && !isHelpDeskAdmin && gohonzonType && (
        <>
          <Box
            style={{
              width: "160px",
              height: "44px",
              flexShrink: "0",
              borderRadius: "35px",
              background: "#196AAB",
              marginBottom: "-25px",
              position: "relative",
              zIndex: "1",
              marginLeft: "45px",
            }}
          >
            <Typography
              variant="title3"
              style={{
                color: "#FFF",
                fontFeatureSettings: "'clig' off, 'liga' off",
                fontFamily: "Noto Sans",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "20px",
                padding: "12px 20px 12px 20px",
                margin: "0px",
              }}
            >
              Interviewed By
            </Typography>
          </Box>
          <Box
            style={{
              borderRadius: "5px 5px 5px 5px",
              border: "1px solid #C2D4EB",
              background: "#F6F6F6",
              padding: "30px 0px 20px 0px",
              borderBottom: "9px solid #196AAB",
              margin: "0px 20px",
            }}
          >
            <Box style={styles.interviewBy}>
              {!isHelpDesk && !isHelpDeskAdmin && gohonzonType && (
                <>
                  <Box flex={0.69}>
                    <Typography variant="mini" color="#5e5e5e" weight={600}>
                      Interviewed By:
                      <Typography variant="small" color="#FF6A69">
                        *
                      </Typography>
                    </Typography>
                  </Box>
                  <Box flex={1} style={{ minWidth: "35.3%", maxWidth: "80%" }}>
                    <Dropdown
                      name="regionId"
                      value={regionIds}
                      options={options}
                      multiple
                      label="Select Region Chief"
                      onChange={(e) =>
                        setRegionIds(
                          typeof e.target.value === "string"
                            ? e.target.value.split(",")
                            : e.target.value
                        )
                      }
                      sx={{ backgroundColor: "#FFF" }}
                    />
                  </Box>
                </>
              )}
            </Box>
            <Box style={styles.interviewByQuestion}>
              {!isHelpDesk && !isHelpDeskAdmin && gohonzonType && (
                <Box width="60.5%">
                  <GohonzonOtherInput
                    name={GOHONZON_SUBMISSION.APPORVED_BY_ALL_COMMITE_MEMBERS}
                    value={
                      values[
                        GOHONZON_SUBMISSION.APPORVED_BY_ALL_COMMITE_MEMBERS
                      ]
                    }
                    handleChange={handleChange}
                    preLabel=" Approval by Four Divisional Region Chief's Committee :"
                    required
                    readOnly={readOnly}
                  />
                </Box>
              )}
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
}

export default MemberInterviewedForm;
